var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "row-data tdi-toolbar-card" },
        [
          _vm._m(0),
          _vm.showAdd
            ? _c(
                "el-form",
                {
                  ref: "searchAddForm",
                  staticClass: "tdi-form-grid",
                  attrs: { model: _vm.dataAddSearch, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Chọn ngày" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "140px" },
                        attrs: {
                          type: "date",
                          clearable: false,
                          format: "dd/MM/yyyy",
                          disabled: _vm.checkDisable,
                          "value-format": "yyyy-MM-dd",
                          placeholder: "Chọn ngày",
                          "picker-options": _vm.pickerOptions,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.getAllKidHeightWeight("date")
                          },
                        },
                        model: {
                          value: _vm.dataAddSearch.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataAddSearch, "date", $$v)
                          },
                          expression: "dataAddSearch.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Trạng thái học sinh" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "Trạng thái" },
                          on: {
                            change: function ($event) {
                              return _vm.getAllKidHeightWeight()
                            },
                          },
                          model: {
                            value: _vm.dataAddSearch.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataAddSearch, "status", $$v)
                            },
                            expression: "dataAddSearch.status",
                          },
                        },
                        _vm._l(_vm.kidStatusList, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { value: item.key, label: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.getAppTypeUserLogin === "plus"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Chọn khối" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "140px" },
                              attrs: { placeholder: "Chọn khối" },
                              on: {
                                change: function ($event) {
                                  return _vm.changeGradeDetail()
                                },
                              },
                              model: {
                                value: _vm.dataAddSearch.idGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataAddSearch, "idGrade", $$v)
                                },
                                expression: "dataAddSearch.idGrade",
                              },
                            },
                            _vm._l(_vm.gradeOfSchoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.gradeName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Chọn lớp" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "Chọn lớp" },
                          on: {
                            change: function ($event) {
                              return _vm.getAllKidHeightWeight("date")
                            },
                          },
                          model: {
                            value: _vm.dataAddSearch.idClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataAddSearch, "idClass", $$v)
                            },
                            expression: "dataAddSearch.idClass",
                          },
                        },
                        _vm._l(_vm.classList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.className },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Tìm kiếm học sinh" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "Nhập tên", clearable: "" },
                        on: {
                          change: function ($event) {
                            return _vm.getAllKidHeightWeight()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getAllKidHeightWeight()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("el-button", {
                                    attrs: { icon: "el-icon-search" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getAllKidHeightWeight()
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1784293234
                        ),
                        model: {
                          value: _vm.dataAddSearch.codeOrName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataAddSearch, "codeOrName", $$v)
                          },
                          expression: "dataAddSearch.codeOrName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.showHistory
            ? _c(
                "el-form",
                {
                  ref: "searchHistoryForm",
                  staticClass: "tdi-form-grid",
                  attrs: { model: _vm.dataSearch, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Chọn ngày" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "140px" },
                        attrs: {
                          type: "date",
                          disabled: _vm.checkDisable,
                          placeholder: "Chọn ngày",
                          "picker-options": _vm.pickerOptions,
                        },
                        model: {
                          value: _vm.selectDate,
                          callback: function ($$v) {
                            _vm.selectDate = $$v
                          },
                          expression: "selectDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Trạng thái học sinh" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "Trạng thái" },
                          on: {
                            change: function ($event) {
                              return _vm.getAllKidHeightWeightHistory()
                            },
                          },
                          model: {
                            value: _vm.dataSearch.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataSearch, "status", $$v)
                            },
                            expression: "dataSearch.status",
                          },
                        },
                        _vm._l(_vm.kidStatusList, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { value: item.key, label: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.getAppTypeUserLogin === "plus"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Chọn khối" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "140px" },
                              attrs: { placeholder: "Chọn khối" },
                              on: {
                                change: function ($event) {
                                  return _vm.changeGradeDetailH()
                                },
                              },
                              model: {
                                value: _vm.dataSearch.idGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataSearch, "idGrade", $$v)
                                },
                                expression: "dataSearch.idGrade",
                              },
                            },
                            _vm._l(_vm.gradeOfSchoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.gradeName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Chọn lớp" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "Chọn lớp" },
                          on: {
                            change: function ($event) {
                              return _vm.getAllKidHeightWeightHistory()
                            },
                          },
                          model: {
                            value: _vm.dataSearch.idClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataSearch, "idClass", $$v)
                            },
                            expression: "dataSearch.idClass",
                          },
                        },
                        _vm._l(_vm.classList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.className },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Tìm kiếm học sinh" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          placeholder: "Nhập mã hoặc tên",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.getAllKidHeightWeightHistory()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getAllKidHeightWeightHistory()
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [
                                _c("el-button", {
                                  attrs: { icon: "el-icon-search" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getAllKidHeightWeightHistory()
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.dataSearch.codeOrName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataSearch, "codeOrName", $$v)
                          },
                          expression: "dataSearch.codeOrName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "lblthemlichsu" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "sk-tabs",
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClickTab },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Thêm cân đo", name: "AddHeightWeight" } },
                [
                  _c(
                    "div",
                    { staticClass: "table-content row-data" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingData,
                              expression: "loadingData",
                            },
                          ],
                          ref: "multipleTable",
                          staticClass: "sk-table",
                          attrs: {
                            "empty-text": _vm.textTable,
                            data: _vm.AddHeightWeightList,
                            "highlight-current-row": "",
                            "max-height": _vm.$tableMaxHeight,
                            border: true,
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "selection",
                              width: "55",
                              fixed: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "50",
                              align: "center",
                              fixed: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ và tên",
                              align: "left",
                              fixed: "left",
                              width: "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              width: "140",
                              align: "center",
                              fixed: "left",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            scope.row.birthDay
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "weight",
                              label: "Cân nặng",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "60px",
                                        border: "1px solid #ffffff !important",
                                      },
                                      attrs: { placeholder: "......." },
                                      model: {
                                        value: scope.row.weight,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "weight", $$v)
                                        },
                                        expression: "scope.row.weight",
                                      },
                                    }),
                                    _vm._v("  Kg\n              "),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày cân ",
                              align: "center",
                              width: "200",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticClass: "button-left-class3",
                                      attrs: {
                                        type: "date",
                                        align: "center",
                                        placeholder: "Chọn ngày",
                                        "value-format": "yyyy-MM-dd",
                                        format: "dd/MM/yyyy",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: scope.row.timeWeight,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "timeWeight", $$v)
                                        },
                                        expression: "scope.row.timeWeight",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "height",
                              label: "Chiều cao",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      staticClass: "button-left-class0",
                                      staticStyle: { width: "60px" },
                                      attrs: { placeholder: "......." },
                                      model: {
                                        value: scope.row.height,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "height", $$v)
                                        },
                                        expression: "scope.row.height",
                                      },
                                    }),
                                    _vm._v(
                                      "\n                Cm\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày đo",
                              align: "center",
                              width: "200",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticClass: "button-left-class9",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Chọn ngày",
                                        "value-format": "yyyy-MM-dd",
                                        format: "dd/MM/yyyy",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: scope.row.timeHeight,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "timeHeight", $$v)
                                        },
                                        expression: "scope.row.timeHeight",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "noteCommon",
                              label: "Ghi chú",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      staticStyle: {
                                        border: "1px solid #dcdfe6 !important",
                                      },
                                      attrs: {
                                        type: "textarea",
                                        autosize: { minRows: 3, maxRows: 3 },
                                        placeholder: "Ghi chú chung...",
                                      },
                                      model: {
                                        value: scope.row.noteCommon,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "noteCommon", $$v)
                                        },
                                        expression: "scope.row.noteCommon",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              width: "120",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Lưu bản ghi",
                                          placement: "top",
                                          effect: "dark",
                                        },
                                      },
                                      [
                                        _vm.checkPermission([
                                          "studentQuality_heightWeight_update",
                                        ])
                                          ? _c("el-button", {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                icon: "el-icon-check",
                                                circle: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleSave(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Xem chi tiết",
                                          placement: "top",
                                          effect: "dark",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-view",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleViewDetail(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btt" },
                        [
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleCommand } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-over",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v(
                                    "\n                Tác vụ\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-caret-bottom",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                { staticClass: "el-dropdown-menu-container" },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: "exportExcelRecentTimes",
                                      },
                                    },
                                    [_vm._v("Xuất theo ngày cân mới nhất")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: "exportExcelSelectTime",
                                      },
                                    },
                                    [_vm._v("Xuất theo khoảng thời gian")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportExcelAll" } },
                                    [_vm._v("Xuất các học sinh")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportExcelNew" } },
                                    [_vm._v("Xuất mới nhất trong tháng")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Lịch sử cân đo",
                    name: "HistoryHeightWeight",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "table-content row-data" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingData,
                              expression: "loadingData",
                            },
                          ],
                          staticClass: "sk-table",
                          attrs: {
                            "empty-text": _vm.textTable,
                            data: _vm.kidsHeightWeightHistoryList,
                            "highlight-current-row": "",
                            "max-height": _vm.$tableMaxHeight,
                            border: true,
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "selection",
                              width: "65",
                              fixed: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "60",
                              align: "center",
                              fixed: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ và tên",
                              align: "left",
                              width: "210",
                              fixed: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "weight",
                              label: "Cân nặng (Kg)",
                              width: "110",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timeWeight",
                              label: "Ngày cân mới nhất",
                              width: "170",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "height",
                              label: "Chiều cao (Cm)",
                              width: "110",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timeHeight",
                              label: "Ngày đo mới nhất",
                              width: "170",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "noteCommon",
                              label: "Ghi chú chung",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              width: "100",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Xem chi tiết lịch sử",
                                          placement: "top",
                                          effect: "dark",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-view",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleViewDetail(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btt" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "button-over",
                              attrs: {
                                type: "success",
                                loading: _vm.loadingButton,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.exportExcelKidsHeightWeightNew()
                                },
                              },
                            },
                            [_vm._v("Xuất file Excel\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Xuất theo khoảng thời gian",
            visible: _vm.dialogVisibleSelectMonth,
            size: "sm",
            "show-confirm": true,
            "confirm-text": "Xuất Excel",
            "confirm-icon": "el-icon-download",
            "confirm-type": "success",
            "show-cancel": true,
            "cancel-text": "Hủy",
            "cancel-icon": "el-icon-close",
            "cancel-type": "default",
            "use-panel": "",
            "panel-title": "Chọn khoảng thời gian xuất báo cáo",
            "panel-subtitle":
              "Chọn tháng bắt đầu và kết thúc để thống kê lịch sử chỉ số",
            "panel-icon": "el-icon-date",
            "panel-icon-tone": "success",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleSelectMonth = $event
            },
            cancel: _vm.cancelSelectMonth,
            confirm: _vm.confirmSelectMonth,
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-center py-6" },
            [
              _c("el-date-picker", {
                staticStyle: { width: "280px" },
                attrs: {
                  format: "MM-yyyy",
                  type: "monthrange",
                  align: "center",
                  "unlink-panels": "",
                  "range-separator": "-",
                  "start-placeholder": "Tháng bắt đầu",
                  clearable: false,
                  "end-placeholder": "Tháng kết thúc",
                },
                on: { change: _vm.callDataSearch },
                model: {
                  value: _vm.monthAndYear,
                  callback: function ($$v) {
                    _vm.monthAndYear = $$v
                  },
                  expression: "monthAndYear",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("KidsHeightWeightDetail", {
        ref: "KidsHeightWeightDetail",
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseShowMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tdi-card-head mb-3" }, [
      _c("div", [
        _c("p", { staticClass: "tdi-card-title" }, [
          _vm._v("Quản lý chiều cao, cân nặng học sinh"),
        ]),
        _c("p", { staticClass: "tdi-card-subtitle" }, [
          _vm._v(
            "Theo dõi, đánh giá và thống kê tình hình phát triển thể chất của học sinh"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }